<template>
  <div class="phone">
    <a class="phones" href="tel:+74957773089">8 (495) 777-30-89</a>
  </div>
</template>

<style scoped>
.phones {
  display: block;
  font-size: 20px;
}
@media screen and (max-width: 850px) {
  .phones {
    font-size: 16px;
  }
}
@media screen and (max-width:560px){
  .phone {
    margin-bottom: 10px;
  }
}
</style>